import link from "@/scripts/host";
import handleError from '@/scripts/handleError.js';
import loggedIn from '@/scripts/logged.js';


export default {
  name: 'RestOfTheList',
  props: ['arrayElements', 'top', 'actualPlay', 'isPlaying', 'indexOfStart', 'listNumber', 'listDivide'],
  data() {
    return {
      activeIcon: 'play_circle_outline',
      showAll: false,
      numberOfVotesCast: null,
      numberOfUsedVotes: null,
      allVoted: [],
      waitingRoom: false,
      canVote: true,
      isHover: false,
      
    }
  },
  methods: {
    playMP3(mp3) {
      this.$emit('songURL', mp3);
    },
    goToSong(id) {
      if(!this.$route.path.includes(`/utwór/${id}`)){
        this.$router.push(`/utwór/${id}`)
      }
    },

    //uses in share component
    makeFacebookLink(id, name, date){
      if(date){
        return `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Flp3.polskieradio.pl%2Futwór%2F${id}%2F&quote=${date} na pierwszym miejscu Listy Przebojów Trójki był utwór ${name}`
      }
      return `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Flp3.polskieradio.pl%2Futwór%2F${id}%2F&quote=Zagłosowałem na ${name} w Liście Przebojów Trójki`
    },
    makeMailLink(id, name, date){
      if(date){
        return `mailto:?subject=Z archiwum LP3&body=${date} na pierwszym miejscu Listy Przebojów Trójki był utwór ${name}. Sprawdź: https%3A%2F%2Flp3.polskieradio.pl`
      }
      return `mailto:?subject=Zagłosowałem na ${name} w Liście Przebojów Trójki&body=Zagłosowałem na ${name} w Liście Przebojów Trójki Sprawdź: https%3A%2F%2Flp3.polskieradio.pl%2Futwór%2F${id}%2F`
    },
    makeTwitterLink(id, name, date){
      if(date){
        return `https://twitter.com/intent/tweet?text=${date} na pierwszym miejscu Listy Przebojów Trójki był utwór ${name}. Sprawdź: https%3A%2F%2Flp3.polskieradio.pl`
      }
      return `https://twitter.com/intent/tweet?text=Zagłosowałem na ${name} w Liście Przebojów Trójki Sprawdź: https%3A%2F%2Flp3.polskieradio.pl%2Futwór%2F${id}%2F`
    },
    toggleHover(){
      this.isHover = !this.isHover
    },
    //

   async getVotePossibility() {
    let token = await loggedIn();

      this.axios(`${link.hostLink}SongList/GetCurrentVotingListNumber?typeId=${this.listNumber}`).then((response)=>{
        if(localStorage.user || sessionStorage.user) {
          this.axios({
            method: 'get',
            url: `${link.hostLink}Vote/GetVoteSummary?ListId=${response.data}`,
            headers: {authorization: `${token}`}
          }).then((responseData)=>{
            this.numberOfVotesCast = responseData.data.data.numberOfVotesCast + responseData.data.data.numberOfRemainingVotes;
            this.numberOfUsedVotes= responseData.data.data.numberOfVotesCast;
          }).catch(function(error) {
            handleError(error.response);
          });
        }
      })
    },
    showWaitingRoom(item, index){
      if(index === this.arrayElements.length-1) {
        const same = this;
        setTimeout(function(){
          if(same.$refs.waiting) {
            same.$refs.waiting.forEach((item, i) => {
              if(i>0) {
                item.style.display="none"
              }
            });
          }
        }, 0)
      }
      if(  this.listDivide && item.position-1===this.listDivide[0].numberOfSongs && this.listNumber==='1' && this.indexOfStart) {
        return true
      } else {
        return false
      }
    },
    showLucky13(item, index){
      if(index === this.arrayElements.length-1) {
        const same = this;
        setTimeout(function(){
          if(same.$refs.lucky13) {
            same.$refs.lucky13.forEach((item, i) => {
              if(i>0) {
                item.style.display="none"
              }
            });
          }
        }, 0)
      }
      if( this.listDivide && this.listDivide[2] && item.position-1===this.listDivide[0].numberOfSongs + this.listDivide[1].numberOfSongs && this.listNumber==='1' && this.indexOfStart) {
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    songsList(){
      if(this.indexOfStart) {
        this.getVotePossibility();
        if(this.showAll) {
          return this.arrayElements;
        } else {
          let firstCoupleElement = this.arrayElements.filter(function(value, index){
            if(index<5){
              return value
            }
          })
          return firstCoupleElement;
        }
      } else {
        return this.arrayElements;
      }
    }
  },
  mounted() {
  }
}
